//@flow
import {connect} from 'react-redux';
import {compose} from 'react-recompose';
import {reduxForm} from 'redux-form';
import SIMCardManual from './SIMCardManual';
import {confirmSIMCardNumber} from '../../../modules/SignUp/SIMCardScan';
import ValidationService from '../../../lib/validation';
import {isLoadingSelector} from '../../../modules/LoadingStatus/reducer';
import {
  setCurrentVoucherDetails,
  setVoucherDetailsComeFrom,
  voucherCurrentVoucherDetailsSelector,
} from '../../../modules/Voucher';
import {eSimSelectedSuccess} from '../../../modules/ESim/actions';
import {eSimSelectedSelector} from '../../../modules/ESim';

const validate = values => ({
  number: ValidationService.validateSIMNumber(values.number),
});

const mapStateToProps = state => ({
  isLoading: isLoadingSelector(state, 'confirmSimCardNumber'),
  currentVoucherDetails: voucherCurrentVoucherDetailsSelector(state),
  eSimSelected: eSimSelectedSelector(state),
});

const mapDispatchToProps = {
  onSubmit: confirmSIMCardNumber,
  setCurrentVoucherDetails: (object: Object) =>
    setCurrentVoucherDetails(object),
  setVoucherDetailsComeFrom: (comeFrom: string) =>
    setVoucherDetailsComeFrom(comeFrom),
  selectEsim: eSimSelectedSuccess,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({form: 'SIMCard', validate}),
);

export default enhance(SIMCardManual);
